// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-j_hi","catalogByServiceItem__title":"c-j_hj"};